import { render, staticRenderFns } from "./UploadContainer.vue?vue&type=template&id=535a0c84"
import script from "./UploadContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports